angular.module("Main").factory("SessionService", ["$http", "$q", "NODEBACKEND", "uuid2", "SessionCache", "$location",
    function ($http, $q, NODEBACKEND, uuid2, SessionCache, $location) {

        return {
            setAuthData: setAuthData,
            setAuthDataId: setAuthDataId,
            setSubCategory: setSubCategory,
            setAppointment: setAppointment,
            setUserData: setUserData,
            getAuthData: getAuthData,
            getAuthIdData: getAuthIdData,
            getAuthDtData: getAuthDtData,
            isApp: isApp,
            getUserData: getUserData,
            getSessionId: getSessionId,
            checkSession: checkSession,
            clear: clear,
            setKurs: setKurs,
            setShopData: setShopData,
            currentProject: currentProject,
            isTrainer: isTrainer,
            setShopMVPrice: setShopMVPrice,
            setAggregatorData: setAggregatorData,
            setClubData: setClubData,
            setMemberData: setMemberData

        };

        function setAuthData(clubId, uuid, isApp, isTrainer) {
            let session = {cid: clubId, sid: uuid2.newguid(), id: uuid, isApp: (isApp === true), isTrainer: (uuid === 'tt')};

            SessionCache.set(session);
        }

        function setAuthDataId(clubId, id, isApp, isTrainer) {
            let session = {cid: clubId, sid: uuid2.newguid(), id: id, isApp: (isApp === true), isTrainer: (id === 'tt')};

            SessionCache.set(session);
        }

        function setKurs(kurs, currency) {
            let session = SessionCache.get();

            session.kursData = {
                kurs: kurs,
                Waehrung: currency.Waehrung
            };

            SessionCache.set(session);
        }

        function setShopMVPrice(price) {
            let session = SessionCache.get();
            session.shopData.Preis = price;
        }

        function setShopData(article, currency) {
            let session = SessionCache.get();

            session.shopData = {
                ArtikelNr: article.Nr,
                Bezeichnung: article.Beschreibung ? article.Beschreibung : article.Bezeichnung,
                Preis: article.Preis,
                Beschreibung: article.Beschreibung,
                BeschreibungText: article.BeschreibungText,
                IstPayPal: article.IstPayPal,
                IstLastschrift: article.IstLastschrift,
                IstBar: article.IstBar,
                Waehrung: currency.Waehrung,
                Bild: article.Bild
            };

            SessionCache.set(session);
        }

        function setAggregatorData(aggregator) {
            let session = SessionCache.get();

            session.aggregatorData = {
                Name: aggregator.Name,
                VerknuepfungsBezeichnung: aggregator.VerknuepfungsBezeichnung
            };

            SessionCache.set(session);
        }

        function setClubData(club) {
            let session = SessionCache.get();
            session.aggregatorClubData = {
                selectedMandantNr: club.MandantNr,
                selectedMandantName: !club.MandantOnlineBezeichnung ? club.MandantName : club.MandantOnlineBezeichnung
            }
        }

        function setMemberData(member) {
            let session = SessionCache.get();
            session.aggregatorMemberData = {
            Member: member
            }
        }

        function setSubCategory(sub, currency, without) {
            let session = SessionCache.get();

            session.meetingData = {
                Nr: sub.Nr,
                Name: sub.Bezeichnung,
                Dauer: sub.TDauer,
                Nachlauf: sub.Nachlauf,
                PreisZahl: sub.PreisZahl,
                Waehrung: currency.Waehrung,
                Farbe: sub.Farbe,
                Bezahlung: sub.Buchungssystem_Terminarten.Bezahlung,
                IstKostenfreiAnzeige: sub.IstKostenfreiAnzeige,
                Buchungszeitraum: sub.Buchungszeitraum,
                MitgliedsOption: sub.Buchungssystem_Terminarten.MitgliedsOption,
                WithoutStep1: without,
                IsSlider: sub.SliderData.IsSlider,
                StartTimeSlider: sub.SliderData.StartTimeSlider,
                EndeTimeSlider: sub.SliderData.EndeTimeSlider,
                BuchungszeitraumBis: sub.BuchungszeitraumBisInStunden,
                LeistungsartenBezeichnung: (sub.TerminartNutzungsrechte.length > 0 && sub.Buchungssystem_Terminarten.MitgliedsOption === 3) ? _.map(sub.TerminartNutzungsrechte, 'Bezeichnung') : [],
                Leistungsarten: (sub.TerminartNutzungsrechte.length > 0 && sub.Buchungssystem_Terminarten.MitgliedsOption === 3) ? _.map(sub.TerminartNutzungsrechte, 'Nutzungsrecht_Nr') : [],
                NutzungsrechteText : sub.Buchungssystem_Terminarten.NutzungsrechteMeldung,
                BuchungslimitMitgliedZulassen: sub.BuchungslimitMitgliedZulassen,
                Altersbeschraenkung: sub.Altersbeschraenkung,
                BezahlartText: sub.Buchungssystem_Terminarten.BezahlartText,
                MessageActiv: sub.NachrichtKundeAktiv,
                InfoLabel: sub.Buchungssystem_Terminarten.NachrichtKundeAktivText,
                PreisNichtAnzeigen: sub.PreisNichtAnzeigen


            };

            SessionCache.set(session);
        }

        function setAppointment(nr, termin) {
            let session = SessionCache.get();

            session.meetingDate = {
                TerminartNr: nr,
                Day: termin.Start,
                End: termin.End,
                RessourceIds: termin.RIds,
                RessourcesAuswahl: termin.RIdsAuswahl,
                ResourcesData: termin.ResourcesData
            };

            SessionCache.set(session);
        }

        function setUserData(userData) {
            let session = SessionCache.get();
            session.globals = {
                currentUser: {
                    email: userData.Email,
                    isMember: userData.IsMember,
                    memberNr: userData.MemberNr,
                    firstName: userData.Firstname,
                    lastName: userData.Lastname,
                    uid: userData.uid,
                    token: userData.token,
                }
            };

            SessionCache.set(session);
        }

        function getAuthData() {
            return SessionCache.get().cid;
        }

        function getAuthIdData() {
            return SessionCache.get().id;
        }

        function getAuthDtData() {
            return SessionCache.get().dt;
        }

        function isApp() {
            return (SessionCache.get().isApp === true);
        }


        function isTrainer() {
            return (SessionCache.get().isTrainer === true);
        }

        function getUserData() {
            let userData = SessionCache.get().globals;
            return (!_.isNil(userData)) ? userData.currentUser : null;
        }

        function getSessionId() {
            return SessionCache.get().sid || null;
        }

        function checkSession() {
            let session = SessionCache.get();
            return {
                user: session.globals,
                meetingData: session.meetingData,
                meetingDate: session.meetingDate,
                kursData: session.kursData,
                shopData: session.shopData,
                aggregatorData: session.aggregatorData,
                aggregatorClubData: session.aggregatorClubData,
                aggregatorMemberData: session.aggregatorMemberData
            };
        }

        function clear(data1, data2, data3) {
            let session = SessionCache.get();

            if (!_.isEmpty(data1))
                session[data1] = null;
            if (!_.isEmpty(data2))
                session[data2] = null;
            if (!_.isEmpty(data3))
                session[data3] = null;

            SessionCache.set(session);
        }

        function currentProject() {
            let kbPaths = ["/kursplan", "/uebersichtkurs", "/kursplan", "/autokurse", "/zahlung/kurs/erfolgt",
                "/buchung/erfolgt", "/zahlung/kurs/abbruch", "/zahlung/kurs/fehlgeschlagen", "/zahlung/kurs/fehler",
                "/zahlung/fehler/already"];
            let tbPaths = ["/angebot", "/termin", "/uebersicht", "/autotermine", "/autologin", "/zahlung/erfolgt",
                "/zahlung/abbruch", "/zahlung/fehlgeschlagen", "/zahlung/fehler"];
            let osPaths = ["/onlinesales"];

            let shopPaths = ["/shop", "/shop/overview", "/shop/success", "/shop/fail", "/shop/fail/pp", "/shop/success/pp"]

            let path = $location.path();

            if (_.indexOf(kbPaths, path) >= 0)
                return "kb";
            if (_.indexOf(tbPaths, path) >= 0)
                return "tb";
            if (_.indexOf(osPaths, path) >= 0)
                return "os";
            if (_.indexOf(shopPaths, path) >= 0)
                return "sh";

            return null;
        }

    }]);